export default __webpack_public_path__ + "static/media/termos.ba008df1.txt";